import styled, { css } from "styled-components";
import { Wrapper } from "AppReact";

const template = styled.div`
  ${({displayState}) => css`
    background: #FFFFFF;
    border-radius: ${displayState?.radius ?? '28px'};
  `}
`;

export default Wrapper(template)
